import $ from 'jquery'
import { trackClickedProductPagePopover } from '@/services/analytics'
import { getAnalyticsTrackingProperties } from '@/catalog/product-analytics'
import 'bootstrap/js/popover'

export const initializePopovers = () => {
  $('.pc-popover').popover({
    placement: 'auto',
    trigger: 'click'
  })

  $('#popover-material')
    .popover({
      html: true,
      placement: 'auto',
      trigger: 'manual',
      title: 'Not all paper is created equal.',
      content: $('#popover-material-content').text()
    })
    .click(async function () {
      $(this).popover('show')
      await trackClickedProductPagePopover(getAnalyticsTrackingProperties())
    })

  $('body').on('click', function (e) {
    const $target = $(e.target)
    if (!($target.is('#popover-material') || $target.hasClass('pc-popover'))) {
      $('#popover-material, .pc-popover').popover('hide')
    }
  })
}
